/** Types */
import * as signatureTypes from "./types";

// TODO: Actions

// Set signature Pad
export const setSignPad = (sign) => {
  return {
    type: signatureTypes.SET_SIGNATURE_PAD.SUCCESS,
    payload: sign,
  };
};

// Set signature Type
export const setSignType = (sign) => {
  return {
    type: signatureTypes.SET_SIGNATURE_TYPE.SUCCESS,
    payload: sign,
  };
};

/* Set signature empty */
export const setIsSignatureEmpty = (isEmpty) => {
  return {
    type: signatureTypes.SET_SIGNATURE_EMPTY.SUCCESS,
    payload: isEmpty,
  };
};



// WEBPACK FOOTER //
// ./src/modules/NTICore/component/Signature/action.js